import { Component, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'

import { ProfileManagement } from '@cyborg-monorepo/hunter/common'

import { AuthService } from '../../../auth/auth.service'
import { ConfirmedValidator } from '../../../helpers/password.validator'

@Component({
  standalone: false,
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
  private formBuilder = inject(FormBuilder)
  private authService = inject(AuthService)
  private activatedRoute = inject(ActivatedRoute)

  public form: FormGroup
  public formSubmitted = false
  public error = ''
  public passRequirements = ProfileManagement.passwordDescription
  public passRegex = new RegExp(ProfileManagement.passwordRegEx)

  constructor() {
    this.form = this.formBuilder.group(
      {
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      },
      { validator: ConfirmedValidator('password', 'confirmPassword') },
    )
  }

  public submitForm(): void {
    const password = this.form.value.confirmPassword
    const resetToken = this.activatedRoute.snapshot.queryParams['resetToken']

    this.error = ''

    this.authService.resetPassword(resetToken, password).subscribe(
      () => {
        this.formSubmitted = true
      },
      (error) => {
        this.error =
          error.message || 'There was an issue resetting your password.'
      },
    )
  }
}
